import { BrowserUtils } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import { useEffect } from 'react';

/**
 * Per Microsofts documentation it is best practice to have a dedicated Logout page to use for
 * Front-channel logout configurations. For our application we are directly calling logout() from the msal instance
 * but this route/page is to support the Front-channel feature should we need to use it.
 * Example: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/msal-react-samples/react-router-sample/src/pages/Logout.jsx
 */
export default function Logout() {
  const { instance } = useMsal();
  const appInsights = useAppInsightsContext();

  useEffect(() => {
    instance
      .logoutRedirect({
        account: instance.getActiveAccount(),
        onRedirectNavigate: () => !BrowserUtils.isInIframe()
      })
      .catch((error: unknown) => {
        const errorTelemetry = error as IExceptionTelemetry;
        appInsights.trackException(errorTelemetry);
      });
  }, [instance, appInsights]);

  return <></>;
}
